import React, { useState } from "react";
import TaskScheduleViewTable from "./taskScheduleView";
import { Link } from "react-router-dom";
import "../util/tables.css";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import { Box } from "@mui/material";
import { useDataView } from "../../contexts/data.view.context";
import * as API from "../api/index";
import { NotificationManager } from "react-notifications";
import ViewDetailsIcon from "../util/detailsModal/viewDetailsIcon";
import ViewEditTaskSchedule from "./viewEditTaskSchedule";
import AppDialog from "../util/appDialog";
import ShowLoadingBar from "../util/showLoadingBar";
import { makeEnvCellRenderer } from "../shared/makeEnvCellRenderer";
import SyncDialog from "../util/confirmMatchDialog";
import { sliceByEnv, getEnvColumnValue, getEnvRow, getRowDiff, mergeFields } from "../shared/envUtils";
import { useFetchOnMount } from "../../hooks/useFetchOnMount";

const TaskSchedules = () => {
  const {
    taskSchedules,
    fetchTaskSchedulesFromAllEnv,
    REACT_APP_ENV,
    envColumn1,
    envColumn2,
    openPromoteModal,
    setOpenPromoteModal,
    openDetailForm,
    editable,
    envCell,
    curRow,
    handleClickOpenDetail,
    handleDetailClose,
    onEditClick,
    handleClickOpen,
    handleClose,
    openMatchModal,
    setOpenMatchModal,
    matchCell,
    matchSelectedFields,
    setMatchSelectedFields,
    matchDirection,
    setMatchDirection,
    handleMatchClickOpen,
    handleMatchClose,
  } = useDataView();

  const columns = [
    {
      id: "schedule_id",
      accessorKey: "schedule_id",
      header: "ID",
      size: 150,
      enableEditing: false,
    },
    {
      id: "task_count",
      accessorKey: "task_count",
      header: "No of Tasks",
      size: 50,
      enableEditing: false,
      Cell: ({ row }) => {
        return (
          <Link to={"/QueryScheduleTasks/" + row.original.schedule_id}>
            {row.original.task_count}
          </Link>
        );
      },
    },
    {
      accessorKey: "schedule_cron",
      header: "Cron",
      size: 150,
    },
    {
      accessorKey: "schedule_state",
      header: "State",
      size: 40,
      Edit: ({ cell, column, table }) => {
        let originalState = cell.row.original.schedule_state;
        const [stateValue, setState] = React.useState(originalState);

        const handleChange = (event) => {
          cell.row._valuesCache.schedule_state = event.target.value;
          setState(event.target.value);
        };

        const items = ["Active", "Disable"];

        const menuItems = items.map((item) => {
          return (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          );
        });

        return (
          <>
            <Box sx={{}}>
              <InputLabel
                id="demo-simple-select-label"
                size="small"
                shrink="true"
                sx={{
                  bottom: -5,
                }}
              >
                State
              </InputLabel>

              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                variant="standard"
                value={stateValue}
                defaultValue={originalState}
                onChange={handleChange}
              >
                {menuItems}
              </Select>
            </Box>
          </>
        );
      },
    },
    {
      accessorKey: "schedule_type",
      header: "Type",
      size: 40,
      Edit: ({ cell, column, table }) => {
        let originalType = cell.row.original.schedule_type;
        const [type, setType] = useState(originalType);

        const handleChange = (event) => {
          cell.row._valuesCache.schedule_type = event.target.value;
          setType(event.target.value);
        };

        const items = ["crontab", "synapse"];

        const menuItems = items.map((item) => {
          return (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          );
        });

        return (
          <>
            <Box sx={{}}>
              <InputLabel
                id="demo-simple-select-label"
                size="small"
                shrink="true"
                sx={{
                  bottom: -5,
                }}
              >
                Type
              </InputLabel>

              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                variant="standard"
                value={type}
                defaultValue={originalType}
                onChange={handleChange}
              >
                {menuItems}
              </Select>
            </Box>
          </>
        );
      },
    },
    {
      accessorKey: "schedule_cmd",
      header: "Cmd",
      size: 250,
    },
    {
      accessorKey: "schedule_group",
      header: "Group",
      size: 50,
    },
  ];

  let detailData = null;

  const handleConfirm = () => {
    const payload = [
      {
        schedule_id: envCell.current.row.original.schedule_id,
        schedule_interval: envCell.current.row.original.schedule_interval,
        schedule_count: envCell.current.row.original.schedule_count,
        schedule_cron: envCell.current.row.original.schedule_cron,
        schedule_state: "Pending",
        schedule_type: envCell.current.row.original.schedule_type,
        schedule_cmd: envCell.current.row.original.schedule_cmd,
        schedule_group: envCell.current.row.original.schedule_group,
        parallel_execute: envCell.current.row.original.parallel_execute,
      },
    ];

    const env = envCell.current.column.id;

    onSubmit(payload, env);
    setOpenPromoteModal(false);
  };

  function viewDetails() {
    return function ({ cell, row }) {
      const cellValue = cell.getValue();
      const tooltip = "View Details";

      return (
        <>
          <ViewDetailsIcon
            row={row}
            tooltip={tooltip}
            onClick={handleClickOpenDetail}
          />
          {cellValue}

          <AppDialog
            open={openDetailForm}
            onClose={handleDetailClose}
            title="Task Schedule Details"
            maxWidth="sm"
          >
            <ViewEditTaskSchedule
              curRow={curRow.current}
              handleDetailClose={handleDetailClose}
              editable={editable}
              onEditClick={onEditClick}
              data={detailData}
            />
          </AppDialog>
        </>
      );
    };
  }

  const onSubmit = (payload, env) => {
    const resourcePath = "integrations/cfg/schedules";

    API.AddRecordToOtherEnv(resourcePath, env, payload).then((response) => {
      if (response.code === 200) {
        NotificationManager.success(
          "Record added to " + env + " env",
          "Task Schedule ",
          10000
        );
        fetchTaskSchedulesFromAllEnv();
      } else {
        NotificationManager.error(response.message, "Failed!", 10000);
      }
    });
  };

  let currentEnvConfig = [];
  let envSlice = { current: [], dev: [], test: [], prod: [] };

  const handleMatchConfirm = (fields, direction) => {
    const current = matchCell.current && matchCell.current.cell.row.original;
    const target = matchCell.current && matchCell.current.targetRow;

    if (!current || !target) {
      setOpenMatchModal(false);
      return;
    }

    // _schedule_id (leading underscore) is required by the backend
    // upsert to take the UPDATE branch instead of silently INSERTing a
    // duplicate — see mergeFields below: it's never in `fields`, so it
    // always comes from whichever row (current/target) is actually
    // being written to.
    const fieldNames = [
      "schedule_id", "schedule_interval", "schedule_count", "schedule_cron",
      "schedule_state", "schedule_type", "schedule_cmd", "schedule_group", "parallel_execute",
      "_schedule_id",
    ];
    const isPush = direction === "push";
    const targetEnvLabel = matchCell.current.cell.column.id;
    const merged = isPush
      ? mergeFields(fieldNames, target, current, fields)
      : mergeFields(fieldNames, current, target, fields);
    const destEnv = isPush ? targetEnvLabel : REACT_APP_ENV;

    API.AddRecordToOtherEnv(
      "integrations/cfg/schedules",
      destEnv,
      [merged]
    ).then((response) => {
      if (response.code === 200) {
        NotificationManager.success(
          isPush
            ? "Record synced to " + targetEnvLabel
            : "Record synced from " + targetEnvLabel,
          "Task Schedule ",
          10000
        );
        fetchTaskSchedulesFromAllEnv();
      } else {
        NotificationManager.error(response.message, "Failed!", 10000);
      }
    });

    setOpenMatchModal(false);
  };

  const customCellAction = makeEnvCellRenderer({
    openPromoteModal, envCell, handleClickOpen, handleClose, handleConfirm: (...args) => handleConfirm(...args),
    handleMatchClickOpen,
  });

  const mainColumns = [
    {
      id: "schedule_id",
      accessorKey: "schedule_id",
      header: "ID",
      size: 300,
      enableEditing: false,
      Cell: viewDetails(),
    },
    {
      accessorKey: "schedule_type",
      header: "Type",
      size: 80,
    },
    {
      id: "task_count",
      accessorKey: "task_count",
      header: "No of Tasks",
      size: 120,
      enableEditing: false,
      Cell: ({ row }) => {
        return (
          <Link to={"/QueryScheduleTasks/" + row.original.schedule_id}>
            {row.original.task_count}
          </Link>
        );
      },
    },
    {
      accessorKey: "schedule_state",
      header: "State",
      size: 100,
      // Cell: handleStateAnimation(),
    },
    {
      accessorKey: "envColumn1",
      header: envColumn1,
      id: envColumn1,
      size: 150,
      Cell: customCellAction,
    },
    {
      accessorKey: "envColumn2", //access nested data with dot notation
      header: envColumn2,
      id: envColumn2,
      size: 150,
      Cell: customCellAction,
    },
  ];
  useFetchOnMount(taskSchedules, fetchTaskSchedulesFromAllEnv);

  if (taskSchedules.length > 0) {
    envSlice = sliceByEnv(taskSchedules, REACT_APP_ENV);
    currentEnvConfig = envSlice.current;

    detailData = currentEnvConfig.map((schedule) => {
      return {
        _schedule_id: schedule._schedule_id,
        schedule_id: schedule.schedule_id,
        schedule_interval: schedule.schedule_interval,
        schedule_count: schedule.schedule_count,
        schedule_cron: schedule.schedule_cron,
        schedule_state: schedule.schedule_state,
        schedule_type: schedule.schedule_type,
        schedule_cmd: schedule.schedule_cmd,
        schedule_group: schedule.schedule_group,
        parallel_execute: schedule.parallel_execute,
      };
    });
  }

  let loading = false;
  if (currentEnvConfig.length === 0) {
    loading = true;
  }

  if (Boolean(loading)) {
    return <ShowLoadingBar title="LIST TASK SCHEDULES" loading={loading} />;
  }

  return (
    <>
      <div className="cache-table">

        {currentEnvConfig.length > 0 && (
          <TaskScheduleViewTable
            columns={columns}
            data={currentEnvConfig.map((querySchedule) => {
              const schedule_id = querySchedule._schedule_id;
              const col1 = getEnvColumnValue({ envColumn: envColumn1, ...envSlice, idKey: "_schedule_id", idValue: schedule_id, valueKey: "schedule_state" });
              const col2 = getEnvColumnValue({ envColumn: envColumn2, ...envSlice, idKey: "_schedule_id", idValue: schedule_id, valueKey: "schedule_state" });
              const targetRow1 = getEnvRow({ envColumn: envColumn1, ...envSlice, idKey: "_schedule_id", idValue: schedule_id });
              const targetRow2 = getEnvRow({ envColumn: envColumn2, ...envSlice, idKey: "_schedule_id", idValue: schedule_id });

              return {
                _schedule_id: querySchedule._schedule_id,
                schedule_id: querySchedule.schedule_id,
                task_count: querySchedule._taskCount_,
                schedule_interval: querySchedule.schedule_interval,
                schedule_count: querySchedule.schedule_count,
                schedule_cron: querySchedule.schedule_cron,
                schedule_state: querySchedule.schedule_state,
                schedule_type: querySchedule.schedule_type,
                schedule_cmd: querySchedule.schedule_cmd,
                schedule_group: querySchedule.schedule_group,
                parallel_execute: querySchedule.parallel_execute,
                envColumn1: col1,
                envColumn2: col2,
                [`${envColumn1}__diff`]: { ...getRowDiff(querySchedule, targetRow1), targetRow: targetRow1 },
                [`${envColumn2}__diff`]: { ...getRowDiff(querySchedule, targetRow2), targetRow: targetRow2 },
              };
            })}
            mainColumns={mainColumns}
          />
        )}

        <SyncDialog
          open={openMatchModal}
          matchCell={matchCell}
          matchSelectedFields={matchSelectedFields}
          setMatchSelectedFields={setMatchSelectedFields}
          matchDirection={matchDirection}
          setMatchDirection={setMatchDirection}
          handleMatchClose={handleMatchClose}
          handleMatchConfirm={(...args) => handleMatchConfirm(...args)}
        />
      </div>
    </>
  );
};

export default TaskSchedules;
